import { jsx as a } from "react/jsx-runtime";
import c from "classnames";
import { SfIconSize as e } from "@storefront-ui/shared";
const l = (r) => {
  switch (r) {
    case e.xs:
      return "w-4 h-4";
    case e.sm:
      return "w-5 h-5";
    case e.lg:
      return "w-8 h-8";
    case e.xl:
      return "w-10 h-10";
    case e["2xl"]:
      return "w-14 h-14";
    case e["3xl"]:
      return "w-24 h-24";
    case e["4xl"]:
      return "w-48 h-48";
    default:
      return "w-6 h-6";
  }
};
function h({
  size: r = e.base,
  className: s,
  children: t = "",
  ...n
}) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      className: c("inline-block fill-current", l(r), s),
      ...n,
      children: t
    }
  );
}
export {
  h as default
};
